import Grid from "@mui/material/Grid";
import Fields from "./Fields";
import Typography from "@mui/material/Typography";

export default function FormPeopleSafety() {
	const section = "people";

	return (
		<Grid container spacing={2} sx={{ width: "100%" }}>
			<Grid item xs={12}>
				<h2>{`People > Safety`}</h2>
			</Grid>
			<Grid item xs={12}>
				<h3>Fields</h3>
				<Typography sx={{ width: "33%", flexShrink: 0 }}>Safety</Typography>
				<Typography sx={{ color: "text.secondary" }}>
					Step: 'people.safety'
				</Typography>
				<Fields title="" source={`${section}.safety`} />
			</Grid>
		</Grid>
	);
}
